import { render, staticRenderFns } from "./Myrecorddetails.vue?vue&type=template&id=11a0ad1c"
import script from "./Myrecorddetails.vue?vue&type=script&lang=js"
export * from "./Myrecorddetails.vue?vue&type=script&lang=js"
import style0 from "./Myrecorddetails.vue?vue&type=style&index=0&id=11a0ad1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports